import $ from 'jquery'
import imagesLoaded from 'imagesloaded'
import Masonry from 'masonry-layout'
import jQueryBridget from 'jquery-bridget'

window.jQuery = window.$ = $

// Initialize imagesLoaded as a jQuery plugin
imagesLoaded.makeJQueryPlugin(jQuery)

// Use jquery-bridget to make Masonry a jQuery plugin
jQueryBridget('masonry', Masonry, jQuery)
